import aplicacaoCampanhaRepository from './aplicacaoCampanhaRepository'
import baixaRepository from './baixaRepository'
import cadastroCampanhaRepository from './cadastroCampanhaRepository'
import chamadaRepository from './chamadaRepository'
import consultaEstoqueRepository from './consultaEstoqueRepository'
import distribuicaoRepository from './distribuicaoRepository'
import entradaRepository from './entradaRepository'
import exportacaoRepository from './exportacaoRepository'
import filaAtendimentoRepository from './filaAtendimentoRepository'
import parametrizacaoRepository from './parametrizacaoRepository'
import registroVacinacaoRepository from './registroVacinacaoRepository'
import relatorioConsolidadoAplicacaoRepository from './relatorioConsolidadoAplicacaoRepository'
import relatorioDeAplicacao from './relatorioDeAplicacao'
import relatorioPosicaoEstoqueRepository from './relatorioPosicaoEstoqueRepository'
import requisicaoRepository from './requisicaoRepository'
import salaVacinacaoRepository from './salaVacinacaoRepository'
import relatorioFaltosoAprazamentoRepository from './relatorioFaltosoAprazamentoRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/imunizacao`

    return {
        aplicacaoCampanha: aplicacaoCampanhaRepository(baseUrl),
        baixa: baixaRepository(baseUrl),
        cadastroCampanha: cadastroCampanhaRepository(baseUrl),
        chamada: chamadaRepository(baseUrl),
        consultaEstoque: consultaEstoqueRepository(baseUrl),
        distribuicao: distribuicaoRepository(baseUrl),
        entrada: entradaRepository(baseUrl),
        exportacao: exportacaoRepository(baseUrl),
        filaAtendimento: filaAtendimentoRepository(baseUrl),
        parametrizacao: parametrizacaoRepository(baseUrl),
        registroVacinacao: registroVacinacaoRepository(baseUrl),
        relatorioConsolidadoAplicacao: relatorioConsolidadoAplicacaoRepository(baseUrl),
        relatorioDeAplicacao: relatorioDeAplicacao(baseUrl),
        relatorioPosicaoEstoque: relatorioPosicaoEstoqueRepository(baseUrl),
        requisicao: requisicaoRepository(baseUrl),
        salaVacinacao: salaVacinacaoRepository(baseUrl),
        relatorioFaltosoAprazamento: relatorioFaltosoAprazamentoRepository(baseUrl),
    }
}
